import { getEnv } from 'common/utils';
import { FastApiAxiosInstance } from 'common/service/axiosInstances';

const message = {
  getMessages: async (params: { page: number; pageSize: number; unRead?: boolean; nextId?: number }) => {
    const { isInternal } = getEnv();
    const environment = isInternal ? 'INNER' : 'OUTER';
    const { data } = await FastApiAxiosInstance.post('/api/v1/message/list', { ...params, environment });
    return {
      list: data.items,
      ...data,
    };
  },
  getNotices: async (params: { page: number; pageSize: number; unRead?: boolean; nextId?: number }) => {
    const { isInternal } = getEnv();
    const environment = isInternal ? 'INNER' : 'OUTER';
    const { data } = await FastApiAxiosInstance.post('/api/v1/message/notice/list', { ...params, environment });
    return {
      list: data.items,
      ...data,
    };
  },
  //已读消息
  readMessage: async (messageIds: number[]): Promise<ExtendAxioResponse<any>> => {
    return await FastApiAxiosInstance.post('/api/v1/message/read', {
      messageIds,
    });
  },
  readAllMessages: async (type: 'message' | 'notice') => {
    const { isInternal } = getEnv();
    const environment = isInternal ? 'INNER' : 'OUTER';
    return await FastApiAxiosInstance.post('/api/v1/message/read/all', { type, environment });
  },
  //获取消息设置
  getMessageSetting: async () => {
    return await FastApiAxiosInstance.get('/api/v1/user/message/setting');
  },
  // 保存消息设置
  updateMessageSetting: async (messageSetting: {
    messageExternal: { [key: string]: boolean };
    messageAllocator: { [key: string]: boolean };
  }) => {
    return await FastApiAxiosInstance.post('/api/v1/user/update/message/setting', { ...messageSetting });
  },
};
export default message;
